import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './shared/AuthContext.tsx';
import { Login } from './Login.tsx';
import { AdminApp } from './admin/AdminApp.tsx';
import { ClienteApp } from './cliente/ClienteApp.tsx';
import { PersonalApp } from './personal/PersonalApp.tsx';
import { OnboardingPage } from './personal/Onboarding.tsx';
import { KioskPage } from './Kiosk.tsx';
import { PrivacidadPage } from './Privacidad.tsx';
import type { Rol } from './shared/tipos.ts';

function PantallaCarga() {
  return (
    <div className="flex h-full items-center justify-center text-neutro-600">
      <div className="text-center">
        <div className="mx-auto mb-3 h-10 w-10 animate-spin rounded-full border-4 border-contorno-var border-t-primario-400" />
        <p className="text-sm">Cargando CONVOCA…</p>
      </div>
    </div>
  );
}

function InicioPorRol({ rol }: { rol: Rol }) {
  if (rol === 'admin' || rol === 'operador') return <Navigate to="/admin" replace />;
  if (rol === 'cliente') return <Navigate to="/cliente" replace />;
  if (rol === 'personal') return <Navigate to="/personal" replace />;
  return <Navigate to="/login" replace />;
}

export function App() {
  const { usuario, cargando } = useAuth();

  if (cargando) return <PantallaCarga />;

  return (
    <Routes>
      <Route path="/login" element={usuario ? <InicioPorRol rol={usuario.rol} /> : <Login />} />

      <Route
        path="/admin/*"
        element={
          usuario && (usuario.rol === 'admin' || usuario.rol === 'operador') ? (
            <AdminApp />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/cliente/*"
        element={
          usuario && usuario.rol === 'cliente' ? <ClienteApp /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/personal/*"
        element={
          usuario && usuario.rol === 'personal' ? <PersonalApp /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/"
        element={usuario ? <InicioPorRol rol={usuario.rol} /> : <Navigate to="/login" replace />}
      />

      <Route path="/invitacion/:token" element={<OnboardingPage />} />
      <Route path="/kiosk" element={<KioskPage />} />
      <Route path="/privacidad" element={<PrivacidadPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
